import { render, staticRenderFns } from "./BoardingScheduleG.vue?vue&type=template&id=04042f6b"
import script from "./BoardingScheduleG.vue?vue&type=script&lang=js"
export * from "./BoardingScheduleG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports